<sfx-toolbar enableDivider>
    <span translate>Applications &amp; integrations</span>
</sfx-toolbar>
<sfx-content>

    <sfx-header disableDividers>
        <span class="title" translate>Applications</span>
    </sfx-header>
    <sfx-section disableContentPadding>
        <div data-flex data-layout="row wrap">
            <div class="card-container">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <img class="avatar" src="images/applications/gmail.png" mat-card-avatar [attr.alt]="'Gmail logo' | translate"/>
                        <mat-card-title>Gmail</mat-card-title>
                        <mat-card-subtitle>
                            <span translate>Gmail sidebar for Chrome</span>
                        </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <p>
                            <span translate>
                                Work in Salesflare from your Gmail inbox.
                                Open an email and get the relevant customer info next to it.
                                Easily reply to an email from Salesflare. Track email opens and clicks.
                            </span>
                        </p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button (click)="installChromePlugin()" [ngClass]="{ 'connected': chromePluginInstalled }" [disabled]="chromePluginInstalled">
                            <span *ngIf="chromePluginInstalled" translate>installed</span>
                            <span *ngIf="!chromePluginInstalled" translate>install</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
            <div class="card-container">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <img class="avatar" src="images/applications/outlook.png" mat-card-avatar [attr.alt]="'Outlook logo' | translate"/>
                        <mat-card-title>Outlook</mat-card-title>
                        <mat-card-subtitle>
                            <span translate>sidebar for Windows, Mac and web</span>
                        </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <p>
                            <span translate>
                                Work in Salesflare from your Outlook inbox.
                                Open an email and get the relevant customer info next to it.
                                Easily reply to an email from Salesflare. Track email opens and clicks.
                            </span>
                        </p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button (click)="showOutlookAddInGuide()">
                            <span translate>INSTALL</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
            <div class="card-container">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <img class="avatar" src="images/applications/app_store.png" mat-card-avatar [attr.alt]="'App Store logo' | translate"/>
                        <mat-card-title>App Store</mat-card-title>
                        <mat-card-subtitle translate>iOS app for iPhone and iPad</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <p>
                            <span translate>
                                Always be connected with your customers. Access Salesflare on the go and get instant notifications.
                                The iOS app also automatically logs a call when you click on a telephone number.
                            </span>
                        </p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button (click)="go('https://apps.apple.com/app/apple-store/id1061142976')">
                            <span translate>Download</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
            <div class="card-container">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <img class="avatar" src="images/applications/play_store.png" mat-card-avatar [attr.alt]="'Play Store logo' | translate"/>
                        <mat-card-title>Play Store</mat-card-title>
                        <mat-card-subtitle translate>Android app for phone and tablet</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <p>
                            <span translate>
                                Always be connected with your customers. Access Salesflare on the go and get instant notifications.
                                The Android app automatically logs all calls with customers by connecting with your phone's call log.
                            </span>
                        </p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button (click)="go('https://play.google.com/store/apps/details?id=org.salesflare.app&referrer=utm_source%3Dsalesflare%26utm_campaign%3Dsettings')">
                            <span translate>Download</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
            <div class="card-container">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <img class="avatar" src="images/applications/linkedin.png" mat-card-avatar [attr.alt]="'LinkedIn logo' | translate"/>
                        <mat-card-title>LinkedIn</mat-card-title>
                        <mat-card-subtitle>
                            <span translate>LinkedIn sidebar for Chrome</span>
                        </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <p>
                            <span translate>
                                Work in Salesflare from LinkedIn & LinkedIn Sales Navigator.
                                Quickly create accounts and contacts from LinkedIn profiles and messaging inbox.
                                Find email addresses and add info automatically.
                            </span>
                        </p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button (click)="installChromePlugin()" [ngClass]="{ 'connected': chromePluginInstalled }" [disabled]="chromePluginInstalled">
                            <span *ngIf="chromePluginInstalled" translate>installed</span>
                            <span *ngIf="!chromePluginInstalled" translate>install</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </sfx-section>
    <sfx-header disableDividers>
        <span class="title" translate>Integrations</span>
    </sfx-header>
    <sfx-section disableContentPadding>
        <div data-flex data-layout="row wrap">
            <div class="card-container">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <img class="avatar" src="images/sf-icon.png" mat-card-avatar [attr.alt]="'Salesflare logo' | translate"/>
                        <mat-card-title>Salesflare</mat-card-title>
                        <mat-card-subtitle>
                            <span translate>Explore Salesflare integrations</span>
                        </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <p>
                            <span translate>
                                Discover all native integrations between Salesflare and other applications as well as the most popular integrations through Zapier and Make.
                                Browse integrations by category and find out which ones are recommended
                            </span>
                        </p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button (click)="go('https://integrations.salesflare.com')">
                            <span translate>Show integrations</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
            <div class="card-container">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <img class="avatar" src="images/applications/zapier.png" mat-card-avatar [attr.alt]="'Zapier logo' | translate"/>
                        <mat-card-title>Zapier</mat-card-title>
                        <mat-card-subtitle translate>
                            Connect thousands of apps via Zapier
                        </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <p>
                            <span translate>
                                Connect Salesflare with thousands of other apps like Google Contacts, MailChimp or your favorite invoicing software.
                                Using the button below you can get access to Salesflare's Zapier triggers and actions.
                            </span>
                        </p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button (click)="go('https://zapier.com/apps/salesflare/integrations')">
                            <span translate>Get started</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
            <div class="card-container">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <img class="avatar" src="images/sf-icon.png" mat-card-avatar [attr.alt]="'Salesflare logo' | translate"/>
                        <mat-card-title>Salesflare</mat-card-title>
                        <mat-card-subtitle translate>
                            Website tracking script
                        </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <p translate>
                            Know when visitors look at your website, which pages and for how long.
                            This script interacts with the email tracking to identify who of your customers goes to your website.
                            Just download the script and copy it at the end of the head tag, just before or after your Google Analytics script.
                        </p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button (click)="showScript()">
                            <span translate>Show script</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
            <div class="card-container">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <img class="avatar" src="images/sf-icon.png" mat-card-avatar [attr.alt]="'Salesflare logo' | translate"/>
                        <mat-card-title>Salesflare</mat-card-title>
                        <mat-card-subtitle translate>
                            Email tracking links
                        </mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <p>
                            <span translate>
                                Track who clicks on your email (via MailChimp or similar) or social media campaigns.
                                Just envelop your hyperlinks with the Salesflare tracking to make it work.
                                Download the guide to learn exactly how.
                            </span>
                        </p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button mat-button (click)="showGuide()">
                            <span translate>Show guide</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </sfx-section>
    <sfx-header disableDividers>
        <span class="title" translate>Zapier templates</span>
    </sfx-header>
    <sfx-section disableContentPadding>
        <div class="zapier-app-directory-container" [id]="zapierAppDirectoryElementId">

        </div>
    </sfx-section>
</sfx-content>
